import { English } from "../../constant/EnglishFallback";

let errorShown = false;

export default function Getcurrentlocation(multiLanguageData) {
  const LanguageData = multiLanguageData?.DashBoard || {};
  const {
    TEXT_ALERT_LOCATION_1 = English.DashBoard.TEXT_ALERT_LOCATION_1,
    TEXT_ALERT_LOCATION_2 = English.DashBoard.TEXT_ALERT_LOCATION_2,
    TEXT_ALERT_LOCATION_3 = English.DashBoard.TEXT_ALERT_LOCATION_3,
    TEXT_ALERT_LOCATION_4 = English.DashBoard.TEXT_ALERT_LOCATION_4
  } = LanguageData || {};
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          errorShown = false;
          resolve(currentLocation(position));
        },
        (error) => {
          console.error("Getcurrentlocation-> Error Getting Geolocation: ", error); // Add for debugging
          showError(
            error,
            resolve,
            TEXT_ALERT_LOCATION_1,
            TEXT_ALERT_LOCATION_2,
            TEXT_ALERT_LOCATION_3,
            TEXT_ALERT_LOCATION_4
          );
        }
      );
    } else {
      console.log("Getcurrentlocation-> Error As Geolocation Is Not Supported");
      resolve(defaultLocation());
    }
  });
}

const currentLocation = (position) => {
  const lat = position?.coords?.latitude;
  const lng = position?.coords?.longitude;
  return { lat, lng };
};

const defaultLocation = () => ({
  lat: 51.0447331,
  lng: -114.0718831,
  default: true
});

const showError = (
  error,
  resolve,
  TEXT_ALERT_LOCATION_1,
  TEXT_ALERT_LOCATION_2,
  TEXT_ALERT_LOCATION_3,
  TEXT_ALERT_LOCATION_4
) => {
  if (!errorShown) {
    errorShown = true;
    switch (error.code) {
      case error.PERMISSION_DENIED:
        alert(TEXT_ALERT_LOCATION_1);
        break;
      case error.POSITION_UNAVAILABLE:
        alert(TEXT_ALERT_LOCATION_2);
        break;
      case error.TIMEOUT:
        alert(TEXT_ALERT_LOCATION_3);
        break;
      case error.UNKNOWN_ERROR:
        alert(TEXT_ALERT_LOCATION_4);
        break;
      default:
        alert(TEXT_ALERT_LOCATION_4);
        break;
    }
  }
  // ✅ Always resolve with default location
  resolve(defaultLocation());
};
